import { useHistory, useParams } from "react-router";
import { BreadCrumb, Header } from "@funcional/react-ui";
import {
  useCreateProgramFamily,
  useSetProgramFamilyRegistrationPolicy,
} from "@pbm/programs-families/hooks";
import ProgramFamilyForm from "@pbm/programs-families/components/ProgramFamilyForm";

export default function CreateProgramFamilyPage() {
  let { programCode }: { programCode: string } = useParams();
  const setRegistrationPolicy = useSetProgramFamilyRegistrationPolicy();

  const { isLoading, isSuccess, mutateAsync } = useCreateProgramFamily();

  const history = useHistory();

  const onSubmit = async (input: any) => {
    const registrationPolicyId = input?.registrationPolicyId;
    delete input.registrationPolicyId;
    try {
      const record = await mutateAsync(Object.assign(input, { programCode }));
      if (record?.code) {
        if (registrationPolicyId) {
          await setRegistrationPolicy.mutateAsync({
            programCode,
            programFamilyCode: record.code,
            registrationPolicyId: registrationPolicyId || null,
          });
        }

        return history.push(
          `/pbm/programs/${programCode}/families/${record.code}`
        );
      }
    } catch (error) {
      console.error(error);
      window.alert(
        "Não foi possível salvar o registro, tente novamente mais tarde."
      );
    }
  };

  return (
    <>
      <Header
        title="Novo Grupo de Produtos"
        backTo={`/pbm/programs/${programCode}/families`}
      >
        <BreadCrumb
          marginBottom={0}
          items={[
            { path: "/pbm/programs", label: "Programas" },
            {
              path: `/pbm/programs/${programCode}`,
              label: programCode,
            },
            {
              path: `/pbm/programs/${programCode}/families`,
              label: "Grupos de Produtos",
            },
            { label: "Novo" },
          ]}
        />
      </Header>

      <ProgramFamilyForm
        isLoading={isLoading || isSuccess}
        onSubmit={onSubmit}
      />
    </>
  );
}
